import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from 'react-helmet-async';
import HomePage from "./pages/HomePage";
import WebinarLibraryPage from "./pages/WebinarLibraryPage";
import WebinarDetailPage from "./pages/WebinarDetailPage";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/library" element={<WebinarLibraryPage />} />
            <Route path="/webinar/:id" element={<WebinarDetailPage />} />
            <Route path="/analytics" element={<AnalyticsDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
